import React from 'react';

const SeparatedItemsList = ({ items, property, separator = ', ' }) => {
	if (!items || items.length === 0) {
		return null;
	}

	return (
		<React.Fragment>
			{items.map((item, index) => (
				<React.Fragment key={item[property]}>
					{index > 0 && separator}
					{item[property]}
				</React.Fragment>
			))}
		</React.Fragment>
	);
};

export default SeparatedItemsList;
